/**
 * Collection mobile: load non-critical CSS (brands/categories sliders) after LCP.
 * Idle@2s still raced Lighthouse simulate — wait for LCP (or 5s fallback).
 */
(function () {
  var el = document.getElementById('collection-noncritical-css-hrefs');
  if (!el) return;
  var hrefs;
  try {
    hrefs = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }

  function loadCSS(href) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    if (!document.querySelector('link[href="' + href + '"]')) {
      document.head.appendChild(link);
    }
  }

  function loadAll() {
    hrefs.forEach(loadCSS);
  }

  function afterLcpThenIdle() {
    var done = false;
    function run() {
      if (done) return;
      done = true;
      if (window.requestIdleCallback) {
        requestIdleCallback(loadAll, { timeout: 2500 });
      } else {
        setTimeout(loadAll, 200);
      }
    }

    if (typeof PerformanceObserver === 'undefined') {
      setTimeout(run, 4000);
      return;
    }

    try {
      var po = new PerformanceObserver(function (list) {
        if (!list.getEntries().length) return;
        try {
          po.disconnect();
        } catch (e) {
          /* ignore */
        }
        run();
      });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (e) {
      setTimeout(run, 4000);
      return;
    }

    setTimeout(run, 5000);
  }

  if (window.innerWidth <= 749) {
    afterLcpThenIdle();
  } else {
    loadAll();
  }
})();
